import axios from "axios";
import BASEURL from "../Config/global";

export const listSorted = async (config) => {
    try {
        const { url, data, key } = config
        const payload = {
            'data': []
        }

        data.forEach((item, index) => {
            payload['data'].push({
                [key]: item?.id,
                position: index + 1
            })
        })

        const response = await axios.patch(BASEURL + url, payload);

        return response;

    } catch (error) {
        console.log(error)
    }
}